import { TmrBaseResource } from 'stylewhere/api'

export class OperationConfigurations extends TmrBaseResource {
  static endpoint = 'profile/api/v1/operations'
}
